import { resolveBackendUrl } from './backendUrl';

function authHeaders(extra = {}) {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

export async function apiGet(path, options = {}) {
  const base = resolveBackendUrl();
  const res = await fetch(`${base}${path}`, {
    method: 'GET',
    headers: authHeaders(options.headers),
    ...options,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw Object.assign(new Error(text || `Request failed: ${res.status}`), { status: res.status });
  }
  return res.json();
}

export async function apiPost(path, body, options = {}) {
  const base = resolveBackendUrl();
  const res = await fetch(`${base}${path}`, {
    method: 'POST',
    headers: authHeaders(options.headers),
    body: body instanceof FormData ? body : JSON.stringify(body),
    ...options,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw Object.assign(new Error(text || `Request failed: ${res.status}`), { status: res.status });
  }
  return res.json();
}

export async function apiPut(path, body, options = {}) {
  const base = resolveBackendUrl();
  const res = await fetch(`${base}${path}`, {
    method: 'PUT',
    headers: authHeaders(options.headers),
    body: JSON.stringify(body),
    ...options,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw Object.assign(new Error(text || `Request failed: ${res.status}`), { status: res.status });
  }
  return res.json();
}

export async function apiDelete(path, options = {}) {
  const base = resolveBackendUrl();
  const res = await fetch(`${base}${path}`, {
    method: 'DELETE',
    headers: authHeaders(options.headers),
    ...options,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw Object.assign(new Error(text || `Request failed: ${res.status}`), { status: res.status });
  }
  return res.json().catch(() => null);
}

export async function apiPostForm(path, formData, options = {}) {
  const base = resolveBackendUrl();
  const token = localStorage.getItem('token');
  const res = await fetch(`${base}${path}`, {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    body: formData,
    ...options,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw Object.assign(new Error(text || `Request failed: ${res.status}`), { status: res.status });
  }
  return res.json();
}
